export default function CorrectIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				id="Vector"
				d="M5.5 0C2.46697 0 0 2.46697 0 5.5C0 8.53303 2.46697 11 5.5 11C8.53303 11 11 8.53303 11 5.5C11 2.46697 8.54147 0 5.5 0ZM8.79493 3.80184L5.06068 8.04301C4.9424 8.17819 4.76498 8.25422 4.58756 8.25422H4.57911C4.39324 8.25422 4.21582 8.16974 4.09754 8.01766L2.20507 5.70276C1.98541 5.43241 2.02765 5.03533 2.298 4.81567C2.56836 4.59601 2.96544 4.6298 3.19355 4.9086L4.6129 6.649L7.84869 2.96544C8.07681 2.70353 8.48234 2.67819 8.74424 2.9063C9.00614 3.13441 9.03149 3.53994 8.80338 3.80184H8.79493Z"
				fill="currentColor"
			/>
		</svg>
	);
}
